import React, { Component } from 'react'
import PropTypes from 'prop-types'

class Slide extends Component {
  constructor(props) {
    super(props)

    this.mouseEnterTimeoutId = null
    this.mouseEnterTimeoutMilliseconds = 800 - 50

    this.handleMouseEnter = this.handleMouseEnter.bind(this)
    this.handleMouseLeave = this.handleMouseLeave.bind(this)
    this.handlePosterOpenClick = this.handlePosterOpenClick.bind(this)
    this.pullSelfTowardSiblings = this.pullSelfTowardSiblings.bind(this)
    this.pushSiblingsAway = this.pushSiblingsAway.bind(this)
    this.pullSiblingsToward = this.pullSiblingsToward.bind(this)
    this.setSelectedTitle = this.setSelectedTitle.bind(this)
  }

  handleMouseEnter() {
    if (this.mouseEnterTimeoutId !== null) {
      clearTimeout(this.mouseEnterTimeoutId)
    }

    this.mouseEnterTimeoutId = setTimeout(() => {
      if (!this.props.posterOpened) {
        this.pushSiblingsAway()
      }
      this.setSelectedTitle()
    }, this.mouseEnterTimeoutMilliseconds)
  }

  handleMouseLeave() {
    if (this.mouseEnterTimeoutId !== null) {
      clearTimeout(this.mouseEnterTimeoutId)

      this.mouseEnterTimeoutId = null
    }

    if (!this.props.posterOpened) {
      this.pullSiblingsToward()
    }
  }

  handlePosterOpenClick() {
    this.pullSiblingsToward()
    this.props.onPosterOpenClick()
  }

  pushSiblingsAway() {
    let elementTransformOrigin = '50% 50%'
    let previousSiblingTranslate3d = 'translate3d(-47.5%, 0, 0)'
    let nextSiblingTranslate3d = 'translate3d(47.5%, 0, 0)'
    let elementIsFirstVisible = false
    let elementIsLastVisible = false

    if (!this.element) {
      return
    }

    if (this.element.getBoundingClientRect().left <= window.outerWidth * .06) {
      elementIsFirstVisible = true

      this.pullSelfTowardSiblings(nextSiblingTranslate3d)

      elementTransformOrigin = '0 50%'
      nextSiblingTranslate3d = 'translate3d(95%, 0, 0)'
    }

    if (this.element.getBoundingClientRect().right >= window.outerWidth - (window.outerWidth * .06)) {
      elementIsLastVisible = true

      this.pullSelfTowardSiblings(previousSiblingTranslate3d)

      elementTransformOrigin = '100% 50%'
      previousSiblingTranslate3d = 'translate3d(-95%, 0, 0)'
    }

    this.element.style.transformOrigin = elementTransformOrigin

    let previousSibling = this.element.previousElementSibling
    let nextSibling = this.element.nextElementSibling

    // limit to moving up to 10 in either direction
    // no need to do them all
    let siblingCounter = 0
    let nextSiblingCounter = 0
    let previousSiblingCounter = 0

    const SIBLING_LIMIT = 10

    if (elementIsFirstVisible) {
      while (nextSibling && siblingCounter < SIBLING_LIMIT) {
        nextSibling.style.transform = nextSiblingTranslate3d
        nextSibling = nextSibling.nextElementSibling
        siblingCounter = siblingCounter + 1
      }
    } else if (elementIsLastVisible) {
      while (previousSibling && siblingCounter < SIBLING_LIMIT) {
        previousSibling.style.transform = previousSiblingTranslate3d
        previousSibling = previousSibling.previousElementSibling
        siblingCounter = siblingCounter + 1
      }
    } else {
      while (previousSibling && previousSiblingCounter < SIBLING_LIMIT) {
        previousSibling.style.transform = previousSiblingTranslate3d
        previousSibling = previousSibling.previousElementSibling
        previousSiblingCounter = previousSiblingCounter + 1
      }

      while (nextSibling && nextSiblingCounter < SIBLING_LIMIT) {
        nextSibling.style.transform = nextSiblingTranslate3d
        nextSibling = nextSibling.nextElementSibling
        nextSiblingCounter = nextSiblingCounter + 1
      }
    }
  }

  pullSelfTowardSiblings(translateLength) {
    if (!this.element) {
      return
    }

    this.element.style.transform = translateLength
  }

  pullSiblingsToward() {
    if (!this.element) {
      return
    }

    this.element.style.transform = ''
    this.element.style.transformOrigin = ''

    for (let i = 0; i < this.element.parentElement.children.length; i++) {
      this.element.parentElement.children[i].style.transform = ''
    }
  }

  setSelectedTitle() {
    this.props.setSelectedTitle(this.props.id)
  }

  render() {
    const styles = {
      slide: {
        zIndex: this.props.selectedTitle === this.props.id && '2',
      },
    }

    let childWithProps = null

    if (this.props.children) {
      childWithProps = React.cloneElement(React.Children.only(this.props.children), {
        handlePosterOpenClick: this.handlePosterOpenClick,
        id: this.props.id,
        posterOpened: this.props.posterOpened,
        selectedTitle: this.props.selectedTitle,
      })
    }

    return (
      <div className="slide" style={styles.slide} ref={(div) => { this.element = div }} onMouseEnter={this.handleMouseEnter} onMouseLeave={this.handleMouseLeave}>
        <div className="slide__spacing">{childWithProps}</div>
      </div>
    )
  }
}

Slide.propTypes = {
  id: PropTypes.number,
  isFirst: PropTypes.bool,
  isLast: PropTypes.bool,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onPosterOpenClick: PropTypes.func,
  posterOpened: PropTypes.bool,
}

Slide.defaultProps = {
  posterOpened: false,
}

export default Slide



// WEBPACK FOOTER //
// ./src/desktop/components/slide/index.js